import React from "react";

const MonoButton = ({
  type = "button",
  onClick,
  children,
  className = "",
  textColor = "",
  ...props
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      {...props}
      className={`
        group inline-flex items-center justify-center gap-2
        font-mono border border-[#AC8E66]/30 rounded-md
        bg-[#1a1a1a] py-2 px-4
        hover:border-[#AC8E66]/90 hover:bg-[#1c1c1c] 
        transition-all duration-300
        text-[#d0cbb8] ${className}
      `}
    >
      <span className="text-[#AC8E66]/40 transition-colors group-hover:text-[#AC8E66]/70">[</span>
      <span className="relative z-10">{children}</span>
      <span className="inline-block transition-all duration-300 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 text-[#AC8E66]">
        →
      </span>
      <span className="text-[#AC8E66]/40 transition-colors group-hover:text-[#AC8E66]/70">]</span>
    </button>
  );
};

export default MonoButton;
